
import { getPhoneTopStyle } from '@/composables/fxwallet'
import { computed, defineComponent, useSlots } from 'vue'
import ChristmasTreeCenter from '../ChristmasTreeCenter.vue'

export default defineComponent({
  components: {
    // ChristmasTreeCenter
  },

  setup () {
    const { phoneStyle } = getPhoneTopStyle()

    return {
      phoneStyle
    }
  }
})
